import React, { useState, useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import useTrainingAuditApi from './config';
import { parseTableParams } from '../../utils/Utils';
import DataTable from '../../components/ui/DataTable';

const Container = styled.div``;

export default function TrainingAuditPage() {
  const { t } = useTranslation();

  const [queryParams, setQueryParams] = useState({ pageSize: 50, pageNumber: 1 });
  const [filterList, setFilterList] = useState([]);

  const { columns, data, fetching, pagination } = useTrainingAuditApi(queryParams);

  const handleDataStateChange = useCallback((action, tableState) => {
    setFilterList(tableState.filterList);
    const params = parseTableParams(tableState, columns);
    setQueryParams(params);
  }, [columns]);

  const handleFilterConfirm = useCallback((newFilterList) => {
    setFilterList(newFilterList);
  }, []);

  return (
    <Container>
      {useMemo(() => (
        <DataTable
          title={t('menu.trainingAudit')}
          fetching={fetching}
          columns={columns}
          data={data}
          totalRowCount={pagination.totalRowCount}
          pageIndex={pagination.pageIndex}
          pageSize={pagination.pageSize}
          filterList={filterList}
          onFilterConfirm={handleFilterConfirm}
          onTableChanged={handleDataStateChange}
        />
      ), [
        t, fetching, columns, data, pagination,
        filterList, handleFilterConfirm, handleDataStateChange,
      ])}
    </Container>
  );
}
